import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppContext } from '../AppContext';

const AlertMessage = ({ type, message }) => {
    const location = useLocation();
    const { showAlertMessage, clearAlertMessage } = useAppContext();

    useEffect(() => {
        // Check if there's a message in the location state
        if (location.state?.message && location.state?.type) {
            showAlertMessage(location.state.type, location.state.message);
        }
        else 
            clearAlertMessage();
    }, [location]);


  if (!message) return null;

  const alertClass = {
    error: "alert-danger",
    success: "alert-success",
    warning: "alert-warning",
  }[type] || "alert-info";

  return (
    <div className={`alert ${alertClass}`} role="alert">
      {message}
    </div>
  );
};

export default AlertMessage;